import { getOrElse } from 'fp-ts/Option';
import { isEmpty } from 'lodash';
import {
  ContainerSpacedBetween,
  ContainerStackedRow,
  IndexContainerHeader,
  MainHeaderTimeRangeContainer,
} from 'modules/intelligentInsights/brandAffinityInsights/components/layout/BrandAffinity.styles';
import { MarginlessBody2 } from 'modules/intelligentInsights/brandAffinityInsights/components/common.styles';
import {
  MAIN_HEADER_TIME_RANGE_TITLE,
  HEADER_TITLE,
} from 'modules/intelligentInsights/brandAffinityInsights/constants';
import { Select } from 'ui/selectv2/Select';
import {
  asTimespanOption,
  asTimespanEnum,
  IntelligentInsightsTimeSpanOptions,
  formatAsCommonDate,
} from 'modules/intelligentInsights/domain.utils';
import {
  defaultHistory,
  useDataManagementContext,
} from 'modules/intelligentInsights/brandAffinityInsights/contexts/dataManagement/DataManagementContext';
import { LastUpdatedDate } from 'modules/intelligentInsights/common/LastUpdatedDate';
import { useCoreContext } from 'modules/intelligentInsights/brandAffinityInsights/contexts/core/CoreContext';

export const BrandAffinityMainHeader = () => {
  const { isLoading } = useCoreContext();
  const { timeSpan, managedInsightsData } = useDataManagementContext();
  const history = getOrElse(() => defaultHistory)(managedInsightsData.history);
  const lastRefresh = isEmpty(history.categories)
    ? 'N/A'
    : formatAsCommonDate(history.categories[history.categories.length - 1]);
  const { selectedTimespan, updateTimespan } = timeSpan;
  return (
    <>
      <ContainerSpacedBetween>
        <ContainerStackedRow>
          <IndexContainerHeader>{HEADER_TITLE}</IndexContainerHeader>
          <LastUpdatedDate isLoading={isLoading} lastUpdatedText={lastRefresh} />
        </ContainerStackedRow>
        <MainHeaderTimeRangeContainer>
          <MarginlessBody2>{MAIN_HEADER_TIME_RANGE_TITLE}</MarginlessBody2>
          <Select
            isMulti={false}
            /*
          // @ts-ignore */
            isSearchable={false}
            options={IntelligentInsightsTimeSpanOptions}
            value={[asTimespanOption(selectedTimespan)]}
            onSelect={([option]) =>
              updateTimespan(
                asTimespanEnum({ value: option?.value, label: option?.label as string }),
              )
            }
          />
        </MainHeaderTimeRangeContainer>
      </ContainerSpacedBetween>
    </>
  );
};
